<template>
  <div class="vueVideoArchive">
    <div class="filterBar">
      <div class="container">
        <ul class="padding-x">
          <li
            v-bind:class="{ active: currentCat === 'all' }"
            v-on:click="filterItems('all')"
            class="catFilterItem"
          >
            {{ alllabel }}
          </li>
          <li
            v-bind:class="{ active: currentCat === cat.category_nicename }"
            class="catFilterItem"
            v-for="cat in categories"
            v-bind:key="cat.term_id"
            v-on:click="filterItems(cat.category_nicename)"
          >
            {{ cat.name }}
          </li>
        </ul>
      </div>
    </div>
    <div class="mobileFilterBar">
      <div class="padding-x">
        <select @change="filterItems(null, 0, $event)">
          <option value="all">{{ showalllabel }}</option>
          <option
            v-bind:value="cat.category_nicename"
            v-for="cat in categories"
            v-bind:key="cat.term_id"
          >
            {{ cat.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="grid-x container">
      <div
        v-for="post in postsToShow"
        v-bind:key="post.post_name"
        class="cell large-4 medium-6"
      >
        <a v-bind:href="post.path" class="vueGridItem">
          <div class="teaserImgContainer">
            <img alt :src="post.featured_img_url" />
            <img class="playBtn" :src="vicon" />
          </div>
          <h3>{{ post.post_title }}</h3>
          <p class="postExcerpt">{{ post.post_excerpt }}</p>
          <div class="postCategory">
            {{ post.categories[0] ? post.categories[0].name : "" }}
          </div>
          <div class="postDate">{{ post.post_date }}</div>
        </a>
      </div>
    </div>
    <button
      v-if="showShowMore"
      class="showMoreBtn"
      v-on:click="filterItems(currentCat, 9)"
    >
      {{ showmorelabel }}
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      postsToShow: [],
      numberOfPostsToShow: 9,
      currentCat: "all",
      showShowMore: true,
    };
  },
  props: {
    posts: Array,
    categories: Array,
    showmorelabel: String,
    alllabel: String,
    showalllabel: String,
    vicon: String,
  },
  methods: {
    filterItems(cat, numberToAdd = 0, event) {
      if (cat !== null) {
        this.currentCat = cat;
      } else {
        cat = event.target.value;
        this.currentCat = cat;
      }

      if (cat === "all") {
        this.postsToShow = this.posts.slice(
          0,
          this.numberOfPostsToShow + numberToAdd
        );
        if (this.posts.length > this.numberOfPostsToShow + numberToAdd) {
          this.showShowMore = true;
        } else {
          this.showShowMore = false;
        }
      } else {
        let filteredPosts = [];
        this.posts.forEach((post) => {
          if (
            post.categories[0] &&
            post.categories[0].category_nicename === cat
          ) {
            filteredPosts.push(post);
          }
        });
        if (filteredPosts.length > this.numberOfPostsToShow + numberToAdd) {
          this.showShowMore = true;
        } else {
          this.showShowMore = false;
        }
        this.postsToShow = filteredPosts.slice(
          0,
          this.numberOfPostsToShow + numberToAdd
        );
      }

      this.numberOfPostsToShow = this.numberOfPostsToShow + numberToAdd;
    },
  },
  mounted() {
    this.filterItems("all");
  },
  updated() {},
};
</script>

<style scoped>
.vueVideoArchive {
  margin: 25px 0;
}

.vueGridItem {
  padding-bottom: 60px;
  text-decoration: none;
  display: block;
  margin: 20px;
  color: #004267;
  text-decoration: none;
}
.vueGridItem:hover > h3,
.vueGridItem:hover > h2 {
  text-decoration: underline;
  color: #333;
}
.vueGridItem:hover > .teaserImgContainer {
  opacity: 0.9;
}
.vueGridItem h3,
.vueGridItem h2 {
  font-family: "Lexend Deca", sans-serif;
  font-size: 22px;
  line-height: 1.27;
  margin-top: 20px;
}
.postExcerpt {
  color: #333;
}
.postCategory {
  font-family: "Beth Ellen", cursive;
  font-size: 16px;
  padding: 10px 15px;
  background: #004267;
  color: white;
  display: inline-block;
  margin-bottom: 10px;
}
.postDate {
  color: #333;
}
.filterBar {
  font-family: "Lexend Deca", sans-serif;
  font-size: 16px;
  font-weight: 300;
  height: 40px;
  line-height: 40px;
  margin-bottom: 50px;
}
.filterBar ul {
  list-style: none;
}
.filterBar ul li {
  display: inline-block;
  margin: 0 10px 5px 0;
  border: 1px solid #004267;
  padding: 0 20px;
}
.showMoreBtn {
  background: #004267;
  color: white;
  width: 267px;
  height: 66px;
  line-height: 66px;
  text-align: center;
  margin: 20px auto;
  display: block;
  font-family: "Lexend Peta", sans-serif;
  text-transform: uppercase;
  border: 0;
  cursor: pointer;
}
.readMoreBtn {
  background: #c9dd03;
  width: 139px;
  height: 66px;
  line-height: 66px;
  text-align: center;
  display: block;
  margin-top: 50px;
}
.catFilterItem {
  cursor: pointer;
  padding-bottom: 10px;
}
.active {
  background: #004267;
  color: white;
}
.mobileFilterBar {
  display: none;
  width: 100%;
  height: 100px;
  margin-bottom: 50px;
}
select {
  width: 100%;
  height: 50px;
  border: solid 2px #004267;
  background-color: #fff;
  outline: none;
  cursor: pointer;
  font-family: "Lexend Deca", sans-serif;
  text-transform: uppercase;
  font-size: 16px;
  font-stretch: condensed;
  line-height: 1;
  letter-spacing: 1px;
  text-align: center;
}
select::-ms-expand {
  display: none; /* remove default arrow on ie10 and ie11 */
}
select:focus {
  outline: 0;
}

.highlight {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 50px;
}
.highlight img {
  width: 100%;
  height: auto;
}
.hightLightContent {
  padding: 40px 50px;
}
.hightLightContent h3,
.hightLightContent h2 {
  margin-bottom: 36px;
  margin-top: 36px;
  font-family: "Lexend Deca", sans-serif;
  font-size: 40px;
  font-weight: 300;
  line-height: 1.2;
  letter-spacing: -0.2px;
}
.teaserImgContainer {
  position: relative;
}
.playBtn {
  position: absolute;
  width: 30px;
  height: auto;
  left: calc(50% - 15px);
  top: 40%;
}

@media screen and (max-width: 1400px) {
  .hightLightContent h3,
  .hightLightContent h2 {
    font-size: 27px;
  }
}
@media screen and (max-width: 1024px) {
  .filterBar {
    display: none;
  }
  .mobileFilterBar {
    display: block;
  }
  .highlight {
    text-align: center;
    display: block;
    margin-bottom: 50px;
  }
  .readMoreBtn {
    margin: 0 auto;
    display: block;
  }
}
</style>
